import { render, staticRenderFns } from "./UIInput.vue?vue&type=template&id=be715cf4"
import script from "./UIInput.vue?vue&type=script&lang=js"
export * from "./UIInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports